// index.jsx
import ReactDOM from 'react-dom/client';
import { Canvas } from '@react-three/fiber';
import { Perf, PerfHeadless } from 'r3f-perf'
import { OrbitControls, Sky } from '@react-three/drei';
import Experience from './Experience';
import Loader from './Loader';
import './style.css';

const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(
  <>
    <Loader />
    <Canvas
      className="r3f"
      camera={{ fov: 70, near: 0.1, far: 2000, position: [-7, 1.5, 6] }}
    >
      <Sky
        distance={450000} // The distance of the sky from the camera
        inclination={0.5} // The vertical offset of the sun (0 to 1)
        azimuth={0.25} // The horizontal position of the sun (0 to 1)
        rayleigh={2} // The Rayleigh scattering coefficient
        turbidity={10} // The atmospheric turbidity (higher values for hazier atmosphere)
        mieCoefficient={0.005} // The Mie scattering coefficient (affects haze)
        mieDirectionalG={0.8} // The directional G value for Mie scattering (affects haze)
        sunPosition={[0, 1, 0]} // The position of the sun (x, y, z)
      />
      <OrbitControls
        enablePan={true}
        enableZoom={true}
        enableRotate={true}
        minPolarAngle={Math.PI / 4} 
        maxPolarAngle={(3 * Math.PI) / 4}
        minAzimuthAngle={-Math.PI / 4} 
        maxAzimuthAngle={Math.PI / 4} 
        minDistance={10} 
        maxDistance={1000} 
      />
      <Perf position="top-left" />
      <Experience />
    </Canvas>
  </>
);
